import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CountryService } from '@/app/services/shared/countries';
import { Router } from '@angular/router';
import { ProjectsService } from '@/app/services/projects/projects.service';
@Component({
  standalone: true,
  imports: [FormsModule, CommonModule],
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.css'],
})
export class CountriesComponent implements OnInit {
  @Input() selectedCountry: any;
  @Input() org_info: any;
  countries: any;
  filteredCountries: any;
  defaultCountry: any;
  searchTerm = '';
  dropdownOpen = false;

  constructor(
    private countryServices: CountryService,
    private router: Router,
    private projectsService: ProjectsService
  ) {}

  ngOnInit(): void {
    const storedCountry = localStorage.getItem('selectedCountry');
    if (storedCountry) {
      this.selectedCountry = JSON.parse(storedCountry);
    }
    if (!this.selectedCountry) {
      this.projectsService.getCountries();
    }
    this.getCountriesList();
  }

  getCountriesList() {
    this.projectsService.getCountries().subscribe({
      next: (response: any) => {
        if (response?.data?.length > 0) {
          this.countries = response.data;
          this.filteredCountries = [...this.countries];
        }
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  onCountrySelect(country: any) {
    this.selectedCountry = country;
    this.dropdownOpen = false;
    this.searchTerm = '';
    this.filteredCountries = [...this.countries];
    this.countryServices.setCountries(this.selectedCountry);
    this.updateOrganizationCountry(this.org_info?.id, country.id);
    this.org_info = {
      ...this.org_info,
      country,
    };
    localStorage.setItem('org_info', JSON.stringify(this.org_info));
  }

  filterCountries() {
    if (this.searchTerm) {
      this.filteredCountries = this.countries.filter((country) =>
        country.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.filteredCountries = [...this.countries];
    }
  }

  updateOrganizationCountry(orgId: number, countryId: number) {
    this.projectsService.updateOrganizationCountry(orgId, countryId).subscribe({
      next: (response: any) => {
        console.log('response', response);
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Check if the click is outside the dropdown container
    const isClickInsideDropdown = target.closest('.custom-select-container') !== null;

    // Close the dropdown if the click is outside
    if (!isClickInsideDropdown) {
      this.dropdownOpen = false;
    }
  }
}
